import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import "@tiney/web-kit/src/theme/global.css";
import "./src/styles/global.css";

import React from "react";
import { QueryClient, QueryClientProvider } from "react-query";

const queryClient = new QueryClient();

export const wrapRootElement = ({ element }) => (
  <QueryClientProvider client={queryClient} contextSharing={true}>
    {element}
  </QueryClientProvider>
);
